import { state, els } from "./state.js";
import { mapboxToken } from "./config.js";
import { resetMap } from "./map.js";
import { safeBounce } from "./utils.js";

function clearTempMarkers() {
  if (state.routeLayer) {
    state.map.removeLayer(state.routeLayer);
    state.routeLayer = null;
  }
  if (state.tempStartMarker) {
    state.map.removeLayer(state.tempStartMarker);
    state.tempStartMarker = null;
  }
  if (state.tempEndMarker) {
    state.map.removeLayer(state.tempEndMarker);
    state.tempEndMarker = null;
  }
}

async function fetchAndDisplayRoute(start, end) {
  var directionsUrl = `https://api.mapbox.com/directions/v5/mapbox/driving/${start.lng},${start.lat};${end.lng},${end.lat}?alternatives=true&geometries=geojson&steps=true&overview=full&language=vi&access_token=${mapboxToken}`;

  try {
    var response = await fetch(directionsUrl);
    var json = await response.json();

    var routeLine = json.routes[0].geometry;
    state.routeLayer = L.geoJSON(routeLine, {
      style: {
        color: "#0019ff",
        weight: 8,
        opacity: 0.75,
      },
    }).addTo(state.map);
    state.routeLayer.on("add", function () {
      state.map.fitBounds(state.routeLayer.getBounds(), { padding: [30, 30] });
    });
    state.map.fitBounds(state.routeLayer.getBounds());

    var distance = (json.routes[0].distance / 1000).toFixed(2);
    var totalSeconds = json.routes[0].duration;
    var hours = Math.floor(totalSeconds / 3600);
    totalSeconds %= 3600;
    var minutes = Math.floor(totalSeconds / 60);
    var durationString = `${hours > 0 ? hours + " hour" + (hours > 1 ? "s" : "") + ", " : ""}${minutes} minutes`;

    var instructionsHtml = `
        <div class="route-header grid grid-cols-[30px_auto] items-center gap-2 mt-4 mb-2 text-sm p-4 rounded bg-gray-800">
            <div class="icon"></div>
            <div>
            <p>${durationString}</p>
            <p>${distance} km</p>
            </div>
        </div>
        <div class="route-step h-max text-sm p-4 rounded bg-gray-800 cursor-pointer hover:bg-gray-700">
        <h4 class="text-sm">Click to view steps</h4>
        <ol class="list-decimal step-list">`;

    json.routes[0].legs[0].steps.forEach(function (step) {
      instructionsHtml += `<li>${step.maneuver.instruction}</li>`;
    });

    instructionsHtml += `</ol></div>`;
    document.getElementById("instructions").innerHTML = instructionsHtml;
  } catch (error) {
    console.error("Error fetching route:", error);
  }
}

function resetNavigation() {
  state.startPoint = null;
  state.endPoint = null;
  state.navigationActivated = false;

  document.getElementById("start-point").value = "";
  document.getElementById("end-point").value = "";
  document.getElementById("instructions-panel").classList.add("!hidden");

  document.getElementById("activate-navigation-btn").textContent =
    mpsString.active_map_nav_btn_text;
  document.getElementById("maps-wrapper").classList.remove("!w-full", "active-navi");
  els.navMess.classList.add("hidden");
  setTimeout(function () {
    state.map.invalidateSize();
  }, 400);

  if (state.routeLayer) {
    state.map.removeLayer(state.routeLayer);
  }
  resetMap();
  clearTempMarkers();
  console.log("Navigation mode reset and panel cleared");
}

export function initNavigation() {
  var activateNavigationControl = L.control({ position: "topright" });
  activateNavigationControl.onAdd = function (map) {
    var div = L.DomUtil.create("div", "activate-navigation-control");
    div.innerHTML = `<button id="activate-navigation-btn">${mpsString.active_map_nav_btn_text}</button>`;
    L.DomEvent.on(div, "click", function (e) {
      L.DomEvent.stopPropagation(e);
      state.navigationActivated = !state.navigationActivated;
      div.innerHTML =
        '<button id="activate-navigation-btn">' +
        (state.navigationActivated
          ? mpsString.deactive_map_nav_btn_text
          : mpsString.active_map_nav_btn_text) +
        "</button>";

      if (state.navigationActivated) {
        document.getElementById("maps-wrapper").classList.add("!w-full", "active-navi");
        document.getElementById("instructions-panel").classList.remove("!hidden");
        els.mapElement.querySelector(".leaflet-control-zoom").classList.add("!block");
        const backBtn = document.querySelector(".child-maps .back-btn");
        if (backBtn) backBtn.style.display = "none";
        document.getElementById("start-point").value = "";
        document.getElementById("end-point").value = "";
        els.navMess.innerHTML = "Click the map to add start waypoints";
        els.navMess.classList.remove("hidden");
        setTimeout(function () {
          state.map.invalidateSize();
        }, 400);
      } else {
        resetNavigation();
        const backBtn = document.querySelector(".child-maps .back-btn");
        if (backBtn) backBtn.style.display = "block";
        els.mapElement.querySelector(".leaflet-control-zoom").classList.remove("!block");
      }
    });
    return div;
  };
  activateNavigationControl.addTo(state.map);

  state.map.on("click", function (e) {
    if (state.navigationActivated) {
      if (state.endPoint) {
        clearTempMarkers();
        state.startPoint = null;
        state.endPoint = null;
      }

      if (!state.startPoint) {
        state.startPoint = e.latlng;
        state.tempStartMarker = L.marker(state.startPoint).addTo(state.map);
        safeBounce(state.tempStartMarker, { duration: 500, height: 100 });

        var trimmedStartLat = state.startPoint.lat.toString().slice(0, 8);
        var trimmedStartLng = state.startPoint.lng.toString().slice(0, 8);
        document.getElementById("start-point").value = `${trimmedStartLat}, ${trimmedStartLng}`;

        els.navMess.classList.add("hidden");
      } else {
        state.endPoint = e.latlng;
        state.tempEndMarker = L.marker(state.endPoint).addTo(state.map);
        safeBounce(state.tempEndMarker, { duration: 500, height: 100 });

        var trimmedEndLat = state.endPoint.lat.toString().slice(0, 8);
        var trimmedEndLng = state.endPoint.lng.toString().slice(0, 8);
        document.getElementById("end-point").value = `${trimmedEndLat}, ${trimmedEndLng}`;

        fetchAndDisplayRoute(state.startPoint, state.endPoint);
      }
    }
  });

  state.map.on("locationfound", function (e) {
    if (state.userLocationMarker) {
      state.userLocationMarker.setLatLng(e.latlng);
    } else {
      state.userLocationMarker = L.marker(e.latlng).addTo(state.map);
    }
    state.userLocationMarker.bindTooltip("You are here", {
      permanent: false,
      direction: "top",
      offset: L.point(-16, -16),
    });
    state.userLocationMarker.on("click", function () {
      safeBounce(state.userLocationMarker, { duration: 500, height: 100 });
      if (state.navigationActivated) {
        if (state.endPoint) {
          clearTempMarkers();
          state.startPoint = null;
          state.endPoint = null;
        }

        if (!state.startPoint) {
          state.startPoint = state.userLocationMarker.getLatLng();
          document.getElementById("start-point").value =
            `${state.startPoint.lat}, ${state.startPoint.lng}`;
          els.navMess.classList.add("hidden");
        } else {
          state.endPoint = state.userLocationMarker.getLatLng();
          document.getElementById("end-point").value =
            `${state.endPoint.lat}, ${state.endPoint.lng}`;
          fetchAndDisplayRoute(state.startPoint, state.endPoint);
        }
      }
    });
  });
}

export { fetchAndDisplayRoute, clearTempMarkers };
